import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight} from "@fortawesome/free-solid-svg-icons";
import INFO from "../../data/user";

import "./styles/projectsDetailList.css";

const ProjectsDetailList = () => {
	return (
		<div className="projects-detail-list">
			{INFO.projects.map((project, index) => (
				<div className="project-detail" key={index}>
						<div className="project-detail-logo">
							{project.logo.map((logo, index) => (
								<div className="project-detail-logo-box" key={index}>
									<img className="project-detail-logo-img" src={logo} alt={logo} />
								</div>
							))}
						</div>
						<div className="project-detail-title">{project.title}</div>
						<div className="project-detail-description">
						{project.descriptions.map((description, index) => (
							<div className="project-detail-description-item" key={index}>{description}</div>
						))}
						</div>
						{project.link && <a className="project-detail-link" href={project.link} target="_blank" rel="noreferrer">
							
							<div className="project-detail-link-text" >
							{project.linkText}
							</div>
							<div className="project-detail-link-icon">
								<FontAwesomeIcon icon={faArrowRight} />
							</div>
						</a>}	
				</div>
			))}
		</div>
	);
};

export default ProjectsDetailList;
